export * from './CreateHospital.async';
export * from './createHospital.interface';
